var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pinnedItemExpired && _vm.authoring),expression:"!pinnedItemExpired && authoring"}],staticClass:"pin"},[_c('v-icon',[_vm._v("mdi-pin")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }